import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/collectionChangePlanPopupQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	collectionEntitlementId: string;
	hamsProductKey: string;
	shouldShowPspLink: boolean;
};

export const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-collection-change-plan-popup" */ './collection-change-plan-popup'
			),
		{
			moduleId: 'edition-awareness-collection-change-plan-popup',
		},
	),
	getPreloadProps: ({
		cloudId,
		collectionEntitlementId,
		hamsProductKey,
		shouldShowPspLink,
	}: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			collectionChangePlanPopupQuery: {
				parameters,
				variables: {
					cloudId,
					collectionEntitlementId,
					hamsProductKey,
					shouldShowPspLink,
				},
			},
		},
	}),
});
